import { debounce } from 'lodash-es';

export const PXAmigobanner = (function () {
	'use strict';

	let amigoBanners;

	function init() {
		amigoBanners = document.querySelectorAll('.pxblock--amigobanner');

		if (amigoBanners.length === 0) return;

		// set_banner_height();

		// window.addEventListener('resize', debounce(set_banner_height, 150));

		$('.pxblock--amigobanner .play-button').click(function () {
			let $btn = $(this),
				$video = $btn.siblings('video'),
				video = $video[0];

			if ($btn.hasClass('paused')) {
				$btn.removeClass('paused');
				video.play();
				$btn.attr('aria-label', 'pause video');
			} else {
				$btn.addClass('paused');
				video.pause();
				$btn.attr('aria-label', 'play video');
			}
		});
	}

	function set_banner_height(banner) {
		if (typeof wp !== 'undefined') return;

		amigoBanners.forEach((banner) => {
			let targetHeight =
				window.innerHeight -
				document.querySelector('.site-header').getBoundingClientRect().height;
			// console.log(targetHeight);
			// console.log($('.site-header').height());
			banner.style.minHeight = Math.floor(targetHeight) + 'px';
		});
	}

	return {
		init: init,
	};
})();
